import styled from 'styled-components';
import { colorCSS, minWidth } from '../../../styles';
import { Row } from '../../../components/grid';
export const Controls = styled.div `
  align-items: center;
  justify-content: space-around;
  display: none;
  gap: 1.5rem;
  @media ${minWidth.lg} {
    display: flex;
    justify-content: ${({ alignStart }) => alignStart ? 'flex-start' : 'flex-end'};
  }
`;
export const DraggableContainer = styled.div `
  overflow-x: hidden;

  ${Row} {
    flex-wrap: nowrap;
    padding-bottom: 1rem;
    width: calc(100% + 2rem);
  }
`;
export const ScrollBar = styled.div `
  background-color: ${colorCSS('N20')};
  border-radius: 0.5rem;
  height: 1rem;
  margin-top: 1rem;
  position: relative;

  @media ${minWidth.lg} {
    display: none;
  }
`;
export const ScrollPosition = styled.div `
  background-color: ${colorCSS('N80')};
  border-radius: 0.5rem;
  height: 1rem;
  position: absolute;
  transition: left ${({ transitionTimeInSeconds }) => transitionTimeInSeconds}s
    ease;
`;
//# sourceMappingURL=FullWidthCarousel.styles.js.map